import getClient from "./config";
import { Client } from "./types";

const client: Client = {
  get: ({ url, config }) => getClient().get(url, config),
  post: ({ url, data, config }) => getClient().post(url, data, config),
  put: ({ url, data, config }) => getClient().put(url, data, config),
};

export default client;
